import {
    SAVE_GROUP_CONNECTED_CLIENTS_GRAPH,
    GROUP_CONNECTED_CLIENTS_GRAPH_API_LOADING
} from '../../constants/graphConstants/connectedClientsGraphConstants';

/**
 * Reducer function for managing group connected client graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const groupConnectedClientsGraphReducer = (state = {
    loading: false, 
    connectedClients : [], 
    yAxisLabels : [], 
    clientCount : [],
    groupConnectedClientError : null
}, action) => {
	switch (action.type) {
		case SAVE_GROUP_CONNECTED_CLIENTS_GRAPH:
            return {
                ...state, 
                loading: false, 
                ...action.payload  
            };
        case GROUP_CONNECTED_CLIENTS_GRAPH_API_LOADING:
            return { 
                ...state,
                loading: action.payload, 
                connectedClients : [], 
                yAxisLabels : [], 
                clientCount : [],
                groupConnectedClientError : null
            };
		default:
			return state;
	}
};